// extracted by mini-css-extract-plugin
export default {"wrapper":"Notice_wrapper"};